import { EditorState } from 'draft-js';
import { PLACEHOLDER_FOR_ACTION_ITEM } from 'Shared/constants/constants';

// This function calculates offset from selection text, avoiding plugins in editorState.
// This is necessary to set correct focus when you first click on the item.
export function getOffsetFromSelection(editorState: EditorState) {
  const { focusOffset, focusNode } = window.getSelection();
  const text = editorState.getCurrentContent().getPlainText();
  const focusText = focusNode?.textContent;
  return PLACEHOLDER_FOR_ACTION_ITEM !== focusText ? text.indexOf(focusText) + focusOffset : 0;
}
